import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { StoreState as EmployeesStoreState } from '~/data/employees';
import { Employees } from '~/data/employees/types';
import { StoreState } from '~/reducer';
import { employeesStateSelector } from '~/selectors';

import { EmployeesIndexed } from '.';

type UseAllEmployeesOutput = EmployeesStoreState & {
  getEmployeeById: (employeeId?: number) => Employees | undefined;
  getActiveEmployeeById: (employeeId?: number) => Employees | undefined;
};

export const useAllEmployees = (): UseAllEmployeesOutput => {
  const reduxData = useSelector((state: StoreState) => {
    return employeesStateSelector(state);
  });
  const { allEmployees, activeEmployees } = reduxData;

  const getEmployeeByIdFromIndexed = useCallback(
    (indexed: EmployeesIndexed) =>
      (employeeId?: number): Employees | undefined => {
        return !!employeeId ? indexed[employeeId] : undefined;
      },
    [],
  );

  return {
    ...reduxData,
    getEmployeeById: getEmployeeByIdFromIndexed(allEmployees),
    getActiveEmployeeById: getEmployeeByIdFromIndexed(activeEmployees),
  };
};
